// @flow
import styled from "styled-components"
import StyledLink from "components/StyledLink"

export const ReservationItemLink = styled(StyledLink)`
  text-decoration: none;
`



// WEBPACK FOOTER //
// ./src/components/ReservationList/styled.js